import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingBag } from "lucide-react";

export default function OrderCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#FDFBF7" }} data-testid="order-cancel-page">
      <div className="text-center max-w-md px-4">
        <div className="w-24 h-24 bg-[#E6E2D3] rounded-full flex items-center justify-center mx-auto mb-8">
          <ShoppingBag className="w-12 h-12 text-[#5A5A5A]" />
        </div>
        <h1 className="text-4xl font-bold text-[#1A1A1A] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Payment Cancelled
        </h1>
        <p className="text-[#5A5A5A] text-lg mb-8">
          No worries! Your cart has been saved. You can try again whenever you're ready.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/checkout" className="flex items-center justify-center gap-2 bg-[#2F5233] text-white px-8 py-4 rounded-full font-bold hover:bg-[#1E3A21] transition-all hover:scale-105" data-testid="retry-checkout-btn">
            Try Again
          </Link>
          <Link to="/shop" className="flex items-center justify-center gap-2 border-2 border-[#2F5233] text-[#2F5233] px-8 py-4 rounded-full font-bold hover:bg-[#2F5233]/5 transition-all" data-testid="back-to-shop-btn">
            <ArrowLeft className="w-5 h-5" /> Back to Shop
          </Link>
        </div>
      </div>
    </div>
  );
}
